<mat-toolbar class="main-header">
  @if (sidenav.mode === "over") {
    <button mat-icon-button (click)="toggleMenu()">
      @if (!sidenav.opened) {
        <mat-icon>menu</mat-icon>
      }
      @if (sidenav.opened) {
        <mat-icon>close</mat-icon>
      }
    </button>
  }
  <button mat-icon-button (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span>WhatsApp</span>
  <span class="toolbar-spacer"></span>
  <button mat-icon-button (click)="refresh()" matTooltip="Actualizar estado">
    <mat-icon>refresh</mat-icon>
  </button>
</mat-toolbar>

<block-ui>
  <div class="whatsapp-page">
    @if (status) {
      <mat-card class="status-card">
        <div class="status-head">
          <div class="status-icon" [class.status-icon--ok]="status.connected">
            <mat-icon>{{ status.connected ? "check_circle" : "chat" }}</mat-icon>
          </div>
          <div>
            <h1>{{ getStatusTitle() }}</h1>
            <p>{{ getStatusDescription() }}</p>
          </div>
        </div>

        <div class="status-grid">
          <div class="status-item">
            <span>Configuración</span>
            <strong>{{ status.enabled ? "Activado" : "Desactivado" }}</strong>
          </div>
          <div class="status-item">
            <span>Conexión</span>
            <strong>{{ status.connection }}</strong>
          </div>
          <div class="status-item">
            <span>Reconexiones</span>
            <strong>{{ status.reconnectionAttempts }}</strong>
          </div>
          <div class="status-item">
            <span>Último código</span>
            <strong>{{ status.lastDisconnectCode || "Sin errores" }}</strong>
          </div>
          @if (status.stoppedReason) {
            <div class="status-item status-item--wide">
              <span>Motivo de parada</span>
              <strong>{{ status.stoppedReason }}</strong>
            </div>
          }
        </div>

        <div class="actions">
          <button
            mat-flat-button
            color="primary"
            [disabled]="!status.enabled || status.connected"
            (click)="start()"
          >
            <mat-icon>play_arrow</mat-icon>
            Arrancar conexión
          </button>
          <button mat-stroked-button color="primary" (click)="refresh()">
            <mat-icon>refresh</mat-icon>
            Actualizar
          </button>
        </div>
      </mat-card>

      @if (status.qr) {
        <mat-card class="qr-card">
          <h2>QR pendiente</h2>
          <p>
            Hay un QR activo. Escanéalo desde WhatsApp para vincular la sesión.
          </p>
          <pre>{{ status.qr }}</pre>
        </mat-card>
      }

      <mat-card class="messages-card">
        <div class="messages-head">
          <h2>Últimos mensajes</h2>
          <span>{{ messages.length }} registros</span>
        </div>

        @if (messages.length === 0) {
          <p class="empty-messages">Todavía no hay mensajes registrados.</p>
        } @else {
          <div class="messages-list">
            @for (message of messages; track message.messageId) {
              <div
                class="message-row"
                [class.message-row--selected]="
                  selectedMessage?.messageId === message.messageId
                "
              >
                <div>
                  <strong>{{ message.jid }}</strong>
                  <span>{{ message.messageId }}</span>
                </div>
                <div class="message-meta">
                  <span
                    class="delivery-chip"
                    [class.delivery-chip--ok]="
                      message.status === 'delivered' ||
                      message.status === 'read' ||
                      message.status === 'played'
                    "
                    [class.delivery-chip--error]="message.status === 'error'"
                  >
                    {{ getMessageStatusLabel(message.status) }}
                  </span>
                  <small>{{ message.updatedAt | date: "dd/MM HH:mm:ss" }}</small>
                  <button
                    mat-stroked-button
                    color="primary"
                    class="detail-btn"
                    (click)="viewMessage(message.messageId)"
                  >
                    <mat-icon>visibility</mat-icon>
                    Detalle
                  </button>
                </div>
              </div>
            }
          </div>
        }
      </mat-card>

      @if (selectedMessage) {
        <mat-card class="message-detail-card">
          <div class="messages-head">
            <h2>Detalle del mensaje</h2>
            <span>{{ selectedMessage.messageId }}</span>
          </div>

          <div class="status-grid">
            <div class="status-item status-item--wide">
              <span>Destinatario</span>
              <strong>{{ selectedMessage.jid }}</strong>
            </div>
            <div class="status-item">
              <span>Estado</span>
              <strong>{{ getMessageStatusLabel(selectedMessage.status) }}</strong>
            </div>
            <div class="status-item">
              <span>Raw status</span>
              <strong>{{ selectedMessage.rawStatus ?? "Sin dato" }}</strong>
            </div>
            <div class="status-item">
              <span>Creado</span>
              <strong>{{ selectedMessage.createdAt | date: "dd/MM HH:mm:ss" }}</strong>
            </div>
            <div class="status-item">
              <span>Actualizado</span>
              <strong>{{ selectedMessage.updatedAt | date: "dd/MM HH:mm:ss" }}</strong>
            </div>
            <div class="status-item">
              <span>Entregado</span>
              <strong>{{
                selectedMessage.deliveredAt
                  ? (selectedMessage.deliveredAt | date: "dd/MM HH:mm:ss")
                  : "Pendiente"
              }}</strong>
            </div>
            <div class="status-item">
              <span>Leído</span>
              <strong>{{
                selectedMessage.readAt
                  ? (selectedMessage.readAt | date: "dd/MM HH:mm:ss")
                  : "Pendiente"
              }}</strong>
            </div>
            @if (selectedMessage.error) {
              <div class="status-item status-item--wide">
                <span>Error</span>
                <strong>{{ selectedMessage.error }}</strong>
              </div>
            }
          </div>
        </mat-card>
      }
    }
  </div>
</block-ui>
